import { Grid, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import StatusIndicator from "./StatusIndicator";
import { checkRECADVParams } from "../../../Js/Common";

const SmartCheckCardAdvanced = (props) => {
  let [reportData, setReportData] = useState([]);

  useEffect(() => {
    if (props.smartCheckResult && props.whatToCheck) {
      setReportData(
        checkRECADVParams(props.whatToCheck, props.smartCheckResult)
      );
    }
  }, [props]);

  return (
    <Grid container>
      <Grid xs={12}>
        {reportData &&
          reportData.length > 0 &&
          reportData.map((val, index) => {
            return (
              <Grid container mt={1}>
                <Grid xs={3}>
                  <Typography variant="h6" fontWeight={"bold"}>
                    {val.word}
                  </Typography>
                </Grid>
                <Grid
                  xs={9}
                  sx={{
                    borderLeft: "solid",
                    borderLeftWidth: 3,
                    borderLeftColor: "#DB8829",
                    px: 2,
                  }}
                >
                  {val.result.map((val1, index1) => {
                    return (
                      <Grid container>
                        <Grid xs={12}>{val1.type}</Grid>
                        <Grid xs={5}>Expected: {val1.expected}</Grid>
                        <Grid xs={5}>
                          Accuracy: {val1.result ? "Accurate" : "Not Accurate"}
                        </Grid>
                        <Grid xs={2}>
                          <StatusIndicator
                            correct={val1.result}
                          ></StatusIndicator>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            );
          })}
      </Grid>
    </Grid>
  );
};

export default SmartCheckCardAdvanced;
